export const UserEndpoints = {
  info: () => '/rest/v2/users/me',
  join: () => '/rest/v1/users/join',
  create: () => '/api/v1/users/createProfile'
}
